import {
    Box,
    Flex,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import React from 'react'
import ProductTileImage from '../../product-tile/partials/product-tile-image'
import DisplayPrice from '../../display-price'
import {useCurrency} from '@salesforce/retail-react-app/app/hooks'
import {PlusIcon} from '../../icons/others'
import {FormattedMessage} from 'react-intl'
import {remCalc} from '../../../theme/_utils'

import {getPriceData} from '../../../utils/product-utils'
import {useGoogleTagManager} from '../../../custom-api/hooks/use-google-tag-manager'
import {item_gtm_event} from '../../../custom-api/layers/default'

const ProductTileBundle = ({product, firstElement, productIndex = undefined}) => {
    const styles = useMultiStyleConfig('Bundle')
    const {currency} = useCurrency()
    const {addLayer} = useGoogleTagManager()

    const discount = product.discountPercentage !== '0%'
    const freeGift = product.discountPercentage === '100%'

    // Replaces the individual product price with the new price in the bundle
    const bundlePriceData = {
        listPrice: product.standardPrice,
        currentPrice: product.price,
        isOnSale: discount,
    }

    const selectItemTileEventGtm = async () => {
        await addLayer(
            item_gtm_event.bind(this, {
                event: 'select_item',
                item_list_name: 'carousel_pdp',
                items: [
                    {
                        item_name: product?.c_defaultName,
                        item_id: product?.id,
                        item_category: product?.c_defaultCategoryName,
                        item_variant: product?.variants?.[0]?.productId,
                        price: +(product?.price / (1 + product?.c_taxRate / 100)).toFixed(2),
                        fullprice: getPriceData(product)?.isOnSale ? 'reduced' : 'fullprice',
                        rating_points: '',
                        // get_reevoo_rating() || get_bv_rating(),
                        erp_category: product?.c_materialGroup,
                        prdha_category: product?.c_prdha_category,
                        index: productIndex + 1,
                        stock_status:
                            product?.inventory?.stockLevel > 0 ? 'in-stock' : 'out-of-stock',
                    },
                ],
            }),
        )
    }

    return (
        <Flex {...styles.bundleCard}>
            {/* The + icon is added to the left of each product in the bundle except the first one in the desktop version 
            while the + icon is shown only under the first product in the mobile version */}
            {firstElement ? (
                <Box {...styles.plusIconContainerMobile}>
                    <PlusIcon />
                </Box>
            ) : (
                <Box {...styles.plusIconContainer}>
                    <PlusIcon />
                </Box>
            )}
            <Flex {...styles.bundleProductCard}>
                <ProductTileImage
                    product={product}
                    enableFavourite={false}
                    variant={'bundle'}
                    priceData={bundlePriceData}
                    customImage={product.image}
                    selectItemTileEventGtm={selectItemTileEventGtm}
                />

                {discount && !freeGift && (
                    <Box {...styles.bundleDiscountLabel}>
                        <span>-{product.discountPercentage}</span>
                    </Box>
                )}

                <Flex {...styles.productDetailsContainer}>
                    <Box {...styles.productDetailNameContainer}>
                        <Text {...styles.productDetailName}>{product.productName}</Text>
                    </Box>
                    {freeGift ? (
                        <Box {...styles.bundleFreeGiftLabel}>
                            <FormattedMessage
                                defaultMessage="Free Gift"
                                id="bundle_free_gift.text"
                            />
                        </Box>
                    ) : (
                        <DisplayPrice
                            priceData={bundlePriceData}
                            currency={currency}
                            listPriceProps={{...styles.productListPrice}}
                            currentPriceProps={{...styles.productDetailPrice}}
                            priceContainerProps={{
                                ...styles.productPriceContainer,
                                marginTop: {base: discount ? remCalc(34) : remCalc(0), lg: 0},
                            }}
                            discountProps={{display: 'none'}}
                            productDetailPriceView={true}
                        />
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

ProductTileBundle.propTypes = {
    variant: PropTypes.string,
    product: PropTypes.object,
    firstElement: PropTypes.bool,
    productIndex: PropTypes.number,
}

export default ProductTileBundle
